<template>
  <div class="app-progress-circles">
    <div
      v-for="(step, stepIndex) in progressStepsTotal"
      :key="stepIndex"
      class="app-progress-circles__step"
      :class="{'app-progress-circles__step--filled': stepIndex === index }"
    />
  </div>
</template>

<script>
import postAppProgress from '@/mixins/post-app-progress'

export default {
  // Name
  name: 'app-progress-circles',

  // Mixins
  mixins: [postAppProgress],

  // Props
  props: {
    index: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped lang="scss">
.app-progress-circles {
  display: flex;
  justify-content: center;
  margin: 30px 0;

  @include breakpoint('tablet-portrait-up') {
    margin: 70px 0 40px;
  }

  &__step {
    width: 8px;
    height: 8px;
    margin: 0 4px;
    background-color: #fff;
    border-radius: 50%;
    border: 1px solid #D6D6D6;
    transition: all 150ms ease-in;

    &--filled {
      border-color: transparent;
      background-color: $brand-color-primary;
    }
  }
}
</style>
